<div class="header header--desktop">
    <div class="container flex justify-between">
        <div class="header__left">
            <div [routerLink]="isLoggedIn ? '/policies' : '/authentication/login'" class="flex cursor-pointer">
                <img class="header__logo" src="/assets/images/ps-logo.png" />
            </div>
        </div>
        <div class="header__right">
            <div *ngIf="isLoggedIn" [ngClass]="getRouteCssClass('policies')" class="href-link" routerLink="/policies">
                <div class="header__icon">
                    <mat-icon>request_quote</mat-icon>
                </div>
                <div class="header__label" translate>Policy</div>
            </div>
            <div
                *ngIf="isLoggedIn"
                [ngClass]="getRouteCssClass('my-account')"
                class="href-link"
                routerLink="/my-account">
                <div class="header__icon">
                    <mat-icon>account_circle</mat-icon>
                </div>
                <div class="header__label" translate>Account</div>
            </div>
            <div
                *ngIf="isLoggedIn"
                [ngClass]="getRouteCssClass('contact-us')"
                class="href-link"
                routerLink="/contact-us">
                <div class="header__icon">
                    <mat-icon>perm_phone_msg</mat-icon>
                </div>
                <div class="header__label" translate>Contact Us</div>
            </div>
            <!--            <div *ngIf="isLoggedIn" [ngClass]="getRouteCssClass('concierge')" class="href-link" routerLink="/concierge">-->
            <!--                <div class="header__icon">-->
            <!--                    <mat-icon>info</mat-icon>-->
            <!--                </div>-->
            <!--                <div class="header__label" translate>Concierge</div>-->
            <!--            </div>-->
            <!--            <div (click)="onViewPersonalFinanceBooklet()" *ngIf="isLoggedIn" class="href-link">-->
            <!--                <div class="header__icon">-->
            <!--                    <mat-icon>request_quote</mat-icon>-->
            <!--                </div>-->
            <!--                <div class="header__label" translate>Personal Finance Booklet</div>-->
            <!--            </div>-->
            <app-translator-dropdown></app-translator-dropdown>
            <div (click)="onLogout()" *ngIf="isLoggedIn" class="href-link">
                <div class="header__icon">
                    <mat-icon>logout</mat-icon>
                </div>
                <div class="header__label" translate>Log out</div>
            </div>
        </div>
    </div>
</div>

<div class="header header--mobile">
    <div class="container flex justify-between">
        <div class="header__left">
            <div [routerLink]="isLoggedIn ? '/policies' : '/authentication/login'" class="flex cursor-pointer">
                <img class="header__logo" src="/assets/images/ps-logo.png" />
            </div>
        </div>
        <div class="header__right">
            <app-translator-dropdown></app-translator-dropdown>
            <div *ngIf="isLoggedIn" class="href-link">
                <div (click)="onToggleDrawer()" class="header__icon">
                    <mat-icon>menu</mat-icon>
                </div>
            </div>
        </div>
    </div>
</div>
